import React from 'react';
import cx from 'classnames';
import { Row, Col, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import videoIcon from 'src/legacy/images/video_icon.png'
import { FileService }  from "src/utils/file.service"

import _ from 'lodash';
import styles from './styles.module.scss';

class PlayButton extends React.Component {
  constructor(props){
    super(props);

  }

  render(){
    const metadata = _.get(this.props, "asset.metadata", "");

    if(!FileService.hasVideoAnalytics(metadata)) {
      return null;
    }

    let style={
      width: this.props.size
    }

    return (
       <div className={cx(styles.button, this.props.className)} style={style}>
         <Image  src={videoIcon}/>
       </div>
    );
  } 
}

export default PlayButton;